import React from "react";
import styles from "./progressBar.module.scss";

interface ProgressBarProps {
  progress: number; // Progress value as a percentage (0-100)
}

// Self-styled (not Bootstrap's .progress/.progress-bar) so it renders
// correctly regardless of whether bootstrap.min.css happens to be loaded on
// the page — that CSS is only pulled in as a side effect of an unrelated
// component (DateRange.tsx), so relying on it here made this bar render
// uncolored whenever that component's chunk hadn't loaded yet.
export const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  // Ensure the progress is between 0 and 100
  const safeProgress = Math.min(Math.max(progress, 0), 100);

  return (
    <div className={styles.track}>
      <div
        className={styles.bar}
        role="progressbar"
        style={{ width: `${safeProgress}%` }}
        aria-valuenow={safeProgress}
        aria-valuemin={0}
        aria-valuemax={100}
      ></div>
    </div>
  );
};

export default ProgressBar;
